<template>
  <v-layout
    id="deal-edit-form"
    justify-center
    wrap
  >
    <v-flex
      xs12
      md11
      lg11
    >
      <h2>
        <template v-if="!deal">
          {{ $t('deals.addDeal') }}
        </template>
        <template v-else>
          {{ $t('deals.editDeal') }}
        </template>
      </h2>
      <v-card class="">
        <v-form>
          <v-layout wrap>
            <v-flex
              flex
              lg3
              pa-4
            >
              <v-select
                v-model.trim="form.status"
                :items="statusOptions"
                :label="$t('deals.status')"
                :disabled="!deal"
              >
                <template v-slot:selection="{ item }">
                  <deal-status :name="item" />
                </template>
                <template v-slot:item="{ item }">
                  <deal-status :name="item" />
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs-12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.transaction_amount"
                :label="$t('deals.transaction_amount')"
                hide-details="auto"
                :error-messages="transactionAmountError"
                suffix="USDT"
              />
            </v-flex>
            <v-flex
              v-if="deal"
              xs-12
              md3
              pa-4
            >
              <v-text-field
                v-model.number="form.transaction_fee"
                :label="$t('deals.transaction_fee')"
                hide-details="auto"
                :error-messages="transactionFeeError"
                suffix="USDT"
              />
            </v-flex>
            <v-flex
              v-if="deal"
              xs-12
              md3
              pa-4
            >
              <v-text-field
                v-model.number="form.referrer_fee"
                :label="$t('deals.referrer_fee')"
                hide-details="auto"
                :error-messages="referrerFeeError"
                suffix="USDT"
              />
            </v-flex>
            <v-flex
              flex
              lg12
              mt-3
              pa-4
            >
              <b>
                {{ $t('deals.contacts') }}
              </b>
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.first_name"
                :counter="100"
                :error-messages="first_nameErrors"
                :label="$t('deals.firstNameLabel')+ '*'"
                required
                @input="$v.form.first_name.$touch()"
                @blur="$v.form.first_name.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.last_name"
                :counter="100"
                :error-messages="last_nameErrors"
                :label="$t('deals.lastNameLabel')+ '*'"
                required
                @input="$v.form.last_name.$touch()"
                @blur="$v.form.last_name.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.occupation"
                :counter="100"
                :error-messages="occupationErrors"
                :label="$t('deals.jobLabel')+ '*'"
                required
                @input="$v.form.occupation.$touch()"
                @blur="$v.form.occupation.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-select
                v-model.trim="form.marital_status"
                :items="marriageOptions"
                :item-text="'text'"
                :item-value="'id'"
                :label="$t('deals.marriage')"
                :error-messages="maritalError"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.email"
                :label="$t('deals.emailLabel')"
                required
                hide-details="auto"
                :error-messages="EmailError"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.phone"
                :label="$t('deals.phoneLabel')"
                hide-details="auto"
                :error-messages="PhoneError"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.instagram"
                :label="$t('deals.instaLabel')"
                hide-details="auto"
                prepend-icon="mdi-instagram"
              />
            </v-flex>
            <v-flex
              xs12
              md3
              pa-4
            >
              <v-text-field
                v-model.trim="form.telegram"
                :label="$t('deals.telegramLabel')"
                hide-details="auto"
                prepend-icon="mdi-telegram"
              />
            </v-flex>
            <v-flex
              xs12
              md4
              pa-4
            >
              <v-text-field
                v-model.number="form.sea_dinstance"
                :label="$t('deals.seaDistanceLabel')"
                number
              />
            </v-flex>
            <v-flex
              xs12
              md4
              pa-4
            >
              <v-select
                v-model.trim="form.payment_method"
                :items="paymentMethods"
                :item-text="'text'"
                :item-value="'id'"
                :label="$t('deals.paymentSchemeLabel')"

                :error-messages="paymentMethodError"
              />
            </v-flex>
            <v-flex
              xs12
              md4
              pa-4
            >
              <v-select
                v-model.trim="form.property_status"
                :items="readinessOptions"
                :item-text="'text'"
                :item-value="'id'"
                :label="$t('deals.readinessLabel')"

                :error-messages="propertyStatusError"
              />
            </v-flex>

            <v-flex
              flex
              lg12
              mt-3
              pa-4
            >
              <b>
                {{ $t('deals.kids') }}
              </b>
            </v-flex>

            <v-flex
              xs12
              md2
              pa-4
            >
              <v-select
                v-model.trim="form.hasKids"
                :items="hasKidsOptions"
                :label="$t('deals.hasKidsLabel')"
                @input="setHasKids"
              />
            </v-flex>
            <v-flex
              v-if="!!form.hasKids"
              xs12
              md10
              pa-4
            >
              <v-row
                xs12
              >
                <template v-if="form.kids.length > 0">
                  <v-flex
                    v-for="kid in form.kids"
                    :key="kid[0]"
                    xs12
                    md3
                    pa-4
                  >
                    <v-select
                      v-model="kid[1]"
                      :label="$t('deals.age')"
                      :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]"
                      :hint="$t('deals.child')"
                      persistent-hint

                      @change="setKidAge(kid[0], kid[1])"
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          x-small
                          @click="removeKid(kid[0])"
                        >
                          mdi-minus-circle-outline
                        </v-icon>
                      </template>
                    </v-select>
                  </v-flex>
                </template>
                <v-flex
                  xs12
                  md3
                  pa-4
                >
                  <v-btn
                    small
                    text
                    outlined

                    @click="addKid"
                  >
                    <v-icon>
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                </v-flex>
              </v-row>
            </v-flex>


            <v-flex
              flex
              lg12
            />
            <v-flex
              flex
              md6
              xs12
              pa-4
            >
              <v-flex
                xs12
                mt-3
                pa-4
              >
                <b>
                  {{ $t('deals.aboutLabel') }}
                </b>
              </v-flex>
              <vue-editor
                v-model="form.about_client"
                :editor-toolbar="customToolbar"
              />
              <small
                v-if="DescriptionErrors.length > 0"
                color="error"
              >{{ DescriptionErrors[0] }}</small>
            </v-flex>
            <v-flex
              flex
              md6
              xs12
              pa-4
            >
              <v-flex
                xs12
                mt-3
                pa-4
              >
                <b>
                  {{ $t('deals.comment') }}
                </b>
              </v-flex>
              <vue-editor
                v-model="form.comment"
                :editor-toolbar="customToolbar"
              />
              <small
                v-if="CommentError.length > 0"
                color="error"
              >{{ CommentError[0] }}</small>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md12
            >
              <v-btn
                fab
                outlined
                small
                text
                @click="$emit('closeEditMode', false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn

                color="primary"
                style="float:right"
                :disabled="loading"
                :loading="loading"
                @click="save()"
              >
                {{ $t('globals.saveButton') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-flex>
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('deals.confirmDone')"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-layout>
</template>

<script>
import DEAL_CREATE_MUTATION from "@/graphql/mutations/modules/realEstate/realEstateCreate.gql";
import DEAL_UPDATE_MUTATION from "@/graphql/mutations/modules/realEstate/realEstateUpdate.gql";
import { parsePhoneNumber } from 'awesome-phonenumber'

const check_phone = phone => {
  if (phone == null || phone == "") return true;
  const pn = parsePhoneNumber('+'+phone);
  return pn.valid;
};

import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric
} from "vuelidate/lib/validators";
import { VueEditor, Quill } from "vue2-editor";
import DealStatus from "@/views/Modules/Deals/partial/dealStatus";
import {mapGetters} from "vuex";

export default {
  name: "ModuleProductEditForm",
  components: {
    DealStatus,
    VueEditor,
  },
  mixins: [validationMixin],
  props: {
    deal: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      confirmDialog:false,
      completeConfirmed:false,
      loading: false,
      initialShowKids:false,
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': []}, 'link'],

        ['clean']
      ],
      form: {},
      paymentMethods:[{
            text:this.$t('deals.loan'),
            id:'loan'
          },
          {
            text:"100%",
            id:"cash"
          }
        ],
      readinessOptions:[{
            id:"new",
            text:this.$t('deals.newConstructionLabel')
          },{
            id:"secondary",
            text:this.$t('deals.constructionCompleteLabel')
          },
          {
            id:"pre-construction",
            text:this.$t('deals.constructionIncompleteLabel')
          }
        ],
      marriageOptions:[{
          text:this.$t('deals.marriageSingleLabel'),
            id:"single"
          },
          {
            text:this.$t('deals.marriageMarriedLabel'),
            id:"married"
          }
        ],
      hasKidsOptions:[{
        text:this.$t('globals.yes'),
        value:true
      },
        {
          text:this.$t('globals.no'),
          value:false
        }],
      statusOptions:[
        "new",
        "pending",
        "in_progress",
        "meeting",
        "choosing_property",
        "signing_documents",
        "completed",
        "declined"
      ]
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    rules() {
      var form = {
        first_name:{
          required,
          minLength: minLength(2),
          maxLength: maxLength(100)
        },
        last_name:{
          required,
          minLength: minLength(2),
          maxLength: maxLength(100)
        },
        occupation:{
          required,
          minLength: minLength(2),
          maxLength: maxLength(100)
        },
        marital_status: {
          required
        },
        kids:[],
        payment_method:{
          required
        },
        email:{
          required,
          email
        },
        phone: {
          required,
          check_phone
        },
        instagram:{
          maxLength: maxLength(100)
        },
        telegram: {
          maxLength: maxLength(100)
        },
        about_client:{
          maxLength: maxLength(5000)
        },
        property_status:{
          required
        },
        transaction_amount:{
          required:!!this.deal,
          numeric
        },
        transaction_fee:{
          required:!!this.deal,
          numeric
        },
        referrer_fee:{
          required:!!this.deal,
          numeric
        },
        comment:{
          maxLength: maxLength(5000)
        },
        sea_dinstance:{
          numeric
        }
      }
      return form
    },
    first_nameErrors(value) {
      const errors = [];
      if (!this.$v.form.first_name.$dirty) return errors;
      !this.$v.form.first_name.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.first_name.$params.minLength &&
        errors.push(this.$t("deals.minError", {char: this.$v.form.first_name.$params.minLength.min}));
      !this.$v.form.first_name.maxLength &&
        errors.push(this.$t("deals.maxError", {char: this.$v.form.first_name.$params.maxLength.max}));
      return errors;
    },
    last_nameErrors(value){
      const errors = [];
      if (!this.$v.form.last_name.$dirty) return errors;
      !this.$v.form.last_name.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.last_name.$params.minLength &&
        errors.push(this.$t("deals.minError", {char: this.$v.form.last_name.$params.minLength.min}));
      !this.$v.form.last_name.maxLength &&
        errors.push(this.$t("deals.maxError", {char: this.$v.form.last_name.$params.maxLength.max}));
      return errors;
    },
    occupationErrors(value){
      const errors = [];
      if (!this.$v.form.occupation.$dirty) return errors;
        !this.$v.form.occupation.required &&
      errors.push(this.$t("profile.reqField"));
        !this.$v.form.occupation.minLength &&
      errors.push(this.$t("globals.minError", {char: this.$v.form.occupation.$params.minLength.min}));
      !this.$v.form.occupation.maxLength &&
        errors.push(this.$t("deals.maxError", {char: this.$v.form.occupation.$params.maxLength.max}));
      return errors;
    },
    DescriptionErrors(value) {
      const errors = [];
      if (!this.$v.form.about_client.$dirty) return errors;
      !this.$v.form.about_client.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.about_client.$params.maxLength.max}));
      return errors;
    },
    CommentError(){
      const errors = [];
      if (!this.$v.form.comment.$dirty) return errors;
      !this.$v.form.comment.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.comment.$params.maxLength.max}));
      return errors;
    },
    StatusErrors(value) {
      const errors = [];
      if (!this.$v.form.status.$dirty) return errors;
        !this.$v.form.status.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    EmailError(){
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.email.email &&
        errors.push(this.$t("globals.emailError"));
      return errors;
    },
    PhoneError() {
      const errors = [];
      if (!this.$v.form.phone.$dirty) return errors;
      !this.$v.form.phone.required &&
       errors.push(this.$t("profile.reqField"));
      !this.$v.form.phone.check_phone &&
        errors.push(this.$t("profile.phoneBadFormat"));
      return errors;
    },
    maritalError(){
      const errors = [];
      if (!this.$v.form.marital_status.$dirty) return errors;
      !this.$v.form.marital_status.required &&
        errors.push(this.$t("profile.reqField"));
      return errors;
    },
    paymentMethodError(){
      const errors = [];
      if (!this.$v.form.payment_method.$dirty) return errors;
      !this.$v.form.payment_method.required &&
        errors.push(this.$t("profile.reqField"));
      return errors;
    },
    propertyStatusError(){
      const errors = [];
      if (!this.$v.form.property_status.$dirty) return errors;
      !this.$v.form.property_status.required &&
        errors.push(this.$t("profile.reqField"));

      return errors;
    },
    transactionAmountError(){
      const errors = [];
      if (!this.$v.form.transaction_amount.$dirty) return errors;
      !this.$v.form.transaction_amount.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.transaction_amount.numeric &&
        errors.push(this.$t("deals.mustBeNumber"))
      return errors;
    },
    transactionFeeError(){
      const errors = [];
      if (!this.$v.form.transaction_fee.$dirty) return errors;
      !this.$v.form.transaction_fee.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.transaction_fee.numeric &&
        errors.push(this.$t("deals.mustBeNumber"))
      return errors;
    },
    referrerFeeError(){
      const errors = [];
      if (!this.$v.form.referrer_fee.$dirty) return errors;
      !this.$v.form.referrer_fee.required &&
        errors.push(this.$t("profile.reqField"));
      !this.$v.form.referrer_fee.numeric &&
        errors.push(this.$t("deals.mustBeNumber"))
      return errors;
    },
  },
  watch:{
    'form.kids'(newVal){
      if(typeof newVal == 'string'){
        this.form.kids = JSON.parse(newVal)
      }
    },
  },
  mounted() {
    const form = JSON.parse(JSON.stringify(this.deal))
    this.form = form
    this.form.kids = JSON.parse(form.kids)
    if(this.form.kids.length>0){
      this.setHasKids(true)
    }
    this.form.transaction_amount = form.transaction_amount || 0
    this.form.transaction_fee = form.transaction_fee || 0
    this.form.referrer_fee = form.referrer_fee || 0
  },

  methods: {
    setHasKids(data){
      this.$set(this.form, 'hasKids', data)
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      this.completeConfirmed = confirmed
    },
    addKid(){
      if(this.form.kids){
        this.form.kids.push([this.form.kids.length, 0])
      } else{
        this.form.kids = [this.form.kids.length, 0]
      }
    },
    removeKid(id){
      const index = this.form.kids.map(e => e[0]).indexOf(id);
      this.$delete(this.form.kids, index)
    },
    setKidAge(index, age){
      this.form.kids[index][1] = age
    },
    save() {
      this.$v.$touch();
      if(this.form.status === "completed" && !this.completeConfirmed ){
        this.confirmDialog = true
        return false
      }
      if (!this.$v.$invalid) {
        this.loading = true;
        const vars = this.form
        vars.whitelabel_uuid = this.getWhiteLabel.uuid
        vars.deal_uuid = this.form.uuid
        vars.transaction_amount = parseFloat(this.form.transaction_amount)
        vars.transaction_fee = parseFloat(this.form.transaction_fee)
        vars.referrer_fee = parseFloat(this.form.referrer_fee)
        vars.kids = JSON.stringify(this.form.kids)
        if(this.completeConfirmed){
          vars.pay_fee = true
        }
        this.$apollo
            .mutate({
              mutation: this.deal ? DEAL_UPDATE_MUTATION : DEAL_CREATE_MUTATION,
              variables: vars
            })
            .then(data => {
              this.$emit('closeEditMode', true)
            })
            .catch(error => {
              this.errorHandler(error);
              this.loading = false;
            });
      }else{
        console.log(this.$v)
        return false
      }

    }
  },
}
</script>

<style lang="scss">
#editor {
  height: 400px;
}
#product-edit-form {
  .image {
    width: 306px;
    margin: 0 auto;
    border: 3px solid;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    i {
      margin: 5px 0 0px;
      font-size: 26px;
    }
    p {
      margin: 7px 0 0!important;
      &:first-of-type {
        font-weight: 700;
      }
      line-height: 0.85rem;
    }
    small {
      font-size: 11px;
    }
    &.no-border {
      border: 0 !important;
    }
  }
}
</style>
